import { Component, Input } from '@angular/core';

@Component({
    selector: 'bar-loader',
    styles: [
        `
          .loading {
            visibility: hidden;
          }
        `,
    ],
    template: `
    <div [class.loading]="!loading">
      <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
    </div>
  `,
    standalone: false
})
export class BarLoaderComponent {
  @Input() loading: boolean;
}
